import { Box, Typography } from "@mui/material";
import CriSection from "../../components/CriSection";
import LearningPhoto from "../../assets/images/generic_book_sign.jpg";

const SpeakingEngagement = () => {
  return (
    <CriSection>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            Speaking Engagements
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Gerould Wilhelm, PhD, is available for speaking engagements through
            Conservation Research Institute (CRI). Jerry is an internationally
            renowned botanist and ecologist who has been studying the Chicago
            region flora for over 40-years. He is coauthor, with Laura Rericha,
            of Flora of the Chicago Region: A Floristic and Ecological
            Synthesis, published by the Indiana Academy of Science in 2017. Dr.
            Wilhelm has been requested to speak to many groups over the past
            several decades, from professional botanical societies, to workshops
            and seminars, conservation groups, and local garden clubs. Topics
            close to his heart are listed below, but presentation topics can be
            tailored to a specific request. The base fee-stipend for a speaking
            engagement is $1000, necessary to compensate Jerry for preparation,
            presentation, and travel (for locations within a 25-mile radius from
            Glen Ellyn, Illinois). Speaking engagements are approximately 2 to 3
            hours in length.
          </Typography>

          <ul>
            <li>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  lineHeight: 1.2,
                }}
              >
                Floristic Quality Assessment and Species Conservatism
              </Typography>
            </li>

            <li>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  lineHeight: 1.2,
                }}
              >
                The Ecology and Culture of Water
              </Typography>
            </li>

            <li>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  lineHeight: 1.2,
                }}
              >
                Biblical Environmental Wisdom
              </Typography>
            </li>

            <li>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  lineHeight: 1.2,
                }}
              >
                School of Athens Painting by Raphael
              </Typography>
            </li>

            <li>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  lineHeight: 1.2,
                }}
              >
                Consilience
              </Typography>
            </li>

            <li>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  lineHeight: 1.2,
                }}
              >
                Other topics have included: The Dune Flora; History of Botany in
                Chicago Region
              </Typography>
            </li>
          </ul>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Jerry and Laura are available for book signings for the Flora, which
            can include a brief 35 minute presentation.
          </Typography>
        </Box>

        <Box
          sx={{
            marginLeft: {
              xs: 0,
              md: "36px",
            },
            marginTop: {
              xs: "24px",
              md: 0,
            },
            width: {
              xs: "100%",
              md: "400px",
            },
          }}
        >
          <img
            src={LearningPhoto}
            alt="Learning"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </CriSection>
  );
};

export default SpeakingEngagement;
